import React from 'react';
import PropTypes from 'prop-types';
import FormModal from "../../../components/common/modals/FormModal";
import graphql from "babel-plugin-relay/macro";
import {useFragment, useMutation} from "react-relay";
import {allLanguagesDropdown} from "../../../relay/Fragments";
import {createOptions, sortByDisplayOrder} from "../../../helpers/utils";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import HorizontalFormInput from "../../../components/common/horizontal-form-inputs/HorizontalFormInput";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {bandedSchema, newBandDefaultValues} from "../../../helpers/bandedUtils";

const NewFacilityLocationLanguageModal = ({showModal, onClose, facilityLocationId, languages}) => {
    const mutation = graphql`
    mutation NewFacilityLocationLanguageModalMutation($facilityLocationId: ID!, $languageId: ID!, $seq: Int!, $effectiveFrom: DateOnly!,
    $effectiveTo:DateOnly!) {
        facilityLocation {
            createLanguage(input: {facilityLocationId: $facilityLocationId, languageId: $languageId, seq: $seq, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
                facilityLocationLanguage {
                    id
                    facilityLocation {
                        languages {
                            ...FacilityLocationLanguages_Languages
                        }}}}}}`
    const allLanguages = createOptions(useFragment(allLanguagesDropdown, languages), 'id', 'name');
    const [commitMutation, isInFlight] =  useMutation(mutation);
    const defaultValues = {
        ...newBandDefaultValues,
        facilityLocationId: facilityLocationId,
        languageId: '',
        seq: '',
    }
    const schema = bandedSchema.shape({
        languageId: yup.string().required("Language is required"),
        seq: yup.number().required("Seq is required")
    });
    const methods = useForm({defaultValues: defaultValues, resolver: yupResolver(schema)});

    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (data) => {
                if(data.facilityLocation) {
                    toast.success("Language for Facility Location created")
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"New Language"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
                   buttonText={"Create"}
                   inFlightButtonText={"Creating"}
        >
            <HorizontalFormSelect options={allLanguages} controlId={"languageId"} label={"Language"} />
            <HorizontalFormInput controlId={"seq"} label={"Seq"} type={"number"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
NewFacilityLocationLanguageModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    facilityLocationId: PropTypes.string.isRequired,
    languages: PropTypes.array.isRequired,
}
export default NewFacilityLocationLanguageModal